/**
 * Default `ignoreUrls` patterns for OpenTelemetry fetch/XHR instrumentation on
 * the waiver signing pages.
 *
 * Instrumented: requests to fareharbor.com (apex and subdomains) and
 * fareharbor.engineering. Ignored: static assets, third-party domains, DNS
 * requests.
 *
 * The domain allowlist regex must match both the apex (`fareharbor.com/...`)
 * and subdomain (`api.fareharbor.com/...`) forms. `instrumentation-fetch`
 * normalises every URL to an absolute form before testing, so the regex is
 * always evaluated against a full `https://host/path` string — which means a
 * pattern requiring a leading dot silently drops every same-origin API call
 * made from apex `fareharbor.com`. That bug is why these patterns are spelled
 * out explicitly here.
 *
 * This intentionally mirrors `website/static/js/services/otelIgnoreUrls.js`
 * rather than importing it, to keep `waivers-website` self-contained (the same
 * convention `src/utils/nativeBroadcast.js` follows). The waiver app talks only
 * to first-party endpoints, so it omits the `filestackapi.com` allowance the
 * main site needs. Keep the two in sync when the allowlist changes.
 */
export const IGNORE_URLS_DEFAULT = [
  /\.(png|jpe?g|gif|css|woff2?|svg|ico)$/i,
  /^https?:\/\/(?!([^/?#]+\.)?(?:fareharbor\.com|fareharbor\.engineering)(?:[:/?#]|$))/,
  /^dns:\/\//,
  /^\/dns-query/,
  /\.dns\./,
  /^https?:\/\/[^/]+\.dns\./,
  /\/dns-query\?/,
];
